/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 2/11/2023
 */

import {ScopeFullObj, ScopeAssignedOnlyObj, PermissionsEnum} from "@shared/Permissions/PermissionsEnum.js";
import {
	GrantedAccessFullObj,
} from "@shared/Profile/ClearanceLevelEnum.js";

export const RoleEnum = Object.freeze({
	OWNER: "owner",
	ADMIN: "admin",
	COACH: "coach",
	CLIENT: "client",
	STUDENT: "student",
})

export const defaultPermissionsMap = {
	[RoleEnum.COACH]: [
		//should be in sync with permissions in firestore.rules for coaches, but we don't really use them anywhere in the app so far
	]
}

export let getDefaultPermissionsForRoles = (roles) => {
	let permissions = []
	roles.forEach(role => {
		if (defaultPermissionsMap[role]) {
			permissions = permissions.concat(defaultPermissionsMap[role])
		}
	})
	return permissions
}

let adminDefaultScope = {
	clients: ScopeFullObj,
	// coach: FullAccessObj, //?? don't know if we need this
	resources: ScopeFullObj,
	schedulers: ScopeFullObj,
}
let coachDefaultScope = {
	clients: ScopeAssignedOnlyObj,
	resources: ScopeAssignedOnlyObj,
	schedulers: ScopeAssignedOnlyObj,
}

export const RoleOwnerObj = {label: "Owner", value: RoleEnum.OWNER, defaultScopes: adminDefaultScope, accessLevel: GrantedAccessFullObj}
export const RoleAdminObj = {label: "Admin", value: RoleEnum.ADMIN, defaultScopes: adminDefaultScope, accessLevel: GrantedAccessFullObj, tooltip: "Admins can create, delete and assign clients and other resources"}
export const RoleCoachObj = {label: "Coach", value: RoleEnum.COACH, defaultScopes: coachDefaultScope, accessLevel: GrantedAccessFullObj, tooltip: "Coaches can view or update clients and other resources that they have access to.<br/><br/>They can share available resources with their clients."}
export const RoleClientObj = {label: "Client", value: RoleEnum.CLIENT, defaultScopes: {}, accessLevel: GrantedAccessFullObj} // no default access for clients

export const ScopeObjArray = [
	ScopeFullObj,
	ScopeAssignedOnlyObj
]
export const RoleEnumArray = Object.freeze([
	RoleOwnerObj,
	RoleAdminObj,
	RoleCoachObj,
	RoleClientObj,
])
export const RoleEnumTeamArray = Object.freeze([
	// RoleAdminObj, //TODO implement admin role
	RoleCoachObj,
])

export function getRoleObjByValue(value) {
	return RoleEnumArray.find((role) => role.value === value)
}
export function getScopeObjByValue(value) {
	return ScopeObjArray.find(scopeObj => scopeObj.value === value)
}


